<section class="go-container">

  <go-card class="go-column go-column--100" id="Implementing-table-columns">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Implementing Table Columns</h2>
      <go-copy cardId="Implementing-table-columns" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy go-body-copy--no-margin">
          <code class="code-block--inline">GoTableColumnComponent</code> is required to render columns within
          <code class="code-block--inline">go-table</code> and is exported within <code class="code-block--inline">GoTableModule</code>.
          <code class="code-block--inline">go-table-column</code> cannot render outside of <code class="code-block--inline">go-table</code>.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h3 class="go-heading-3">Bindings</h3>
        <code [highlight]="componentBindings"></code>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">alignment</h4>
        <p class="go-body-copy go-body-copy--no-margin">
          Determines the vertical alignment for the column in respect to all other columns. By default this is set to <code class="code-block--inline">middle</code>.
          This may be set to <code class="code-block--inline">top</code>, <code class="code-block--inline">middle</code>, or <code class="code-block--inline">bottom</code>.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">field</h4>
        <p class="go-body-copy go-body-copy--no-margin">
          Defines data to be shown by linking column to the appropriate key within object defined in <code class="code-block--inline">tableData</code>
          when constructing <code class="code-block--inline">GoTableConfig</code>. For example if <code class="code-block--inline">tableData</code>
          was set to:

          <code [highlight]="fieldExample"></code>
  
          and we wanted "John" to show, then <code class="code-block--inline">field</code> would be set to <code class="code-block--inline">name.first</code>.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">searchable</h4>
        <p class="go-body-copy go-body-copy--no-margin">
          This binding is used in combination with the <code class="code-block--inline">searchConfig</code> in the <code class="code-block--inline">GoTableConfig</code>
          to tell a column whether it's searchable or not. It defaults to <code class="code-block--inline">true</code>, but can be
          turned off for columns that don't make sense with searching, like booleans, images or actionable icons. More information
          can be found <a [routerLink]="['/ui-kit', 'table', 'searching']">here</a>
        </p>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">sortable</h4>
        <p class="go-body-copy go-body-copy--no-margin">
          This binding defines if sorting is enabled for the column. For this binding to work, <code class="code-block--inline">GoTableConfig</code>
          must have <code class="code-block--inline">sortable</code> set to <code class="code-block--inline">true</code>.
          By default sorting is enabled when <code class="code-block--inline">sortable</code> is set to <code class="code-block--inline">true</code>
          within <code class="code-block--inline">GoTableConfig</code>.
        </p>
      </div>
      
      <div class="go-column go-column--100">
        <h4 class="go-heading-4">title</h4>
        <p class="go-body-copy go-body-copy--no-margin">
          This binding sets the column title.
        </p>
      </div>
      
      <div class="go-column go-column--100">
        <h4 class="go-heading-4">width</h4>
        <p class="go-body-copy go-body-copy--no-margin">
          This binding sets the minimum possible width for column. The value must be in pixels.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <h4 class="go-heading-4">wrapContent</h4>
        <p class="go-body-copy go-body-copy--no-margin">
          This binding overrides the <code class="code-block--inline">wrapContent</code> binding on the <code class="code-block--inline">go-table</code>
          component. By default it is unset and will not override the parent table's binding.
        </p>
      </div>

    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="example-usage">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Example Usage</h2>
      <go-copy cardId="example-usage" goCopyCardLink></go-copy>
    </ng-container>
    <ng-container go-card-content>
      <h4 class="go-heading-4">example.html</h4>
      <code [highlight]="basicExample_html"></code>
      <h4 class="go-heading-4">example.ts</h4>
      <code [highlight]="basicExample_ts"></code>
    </ng-container>
  </go-card>

  <go-table class="go-column go-column--100" [tableConfig]="tableConfig" tableTitle="Example Usage">
    <go-table-column field="id" [sortable]="false" width="5"></go-table-column>
    <go-table-column field="active"></go-table-column>
    <go-table-column field="name.first" title="First Name"></go-table-column>
    <go-table-column field="name.last" title="Last Name"></go-table-column>
    <go-table-column field="email" width="50"></go-table-column>
    <go-table-column field="gender"></go-table-column>
    <go-table-column field="ip_address" title="IP Address"></go-table-column>
    <go-table-column field="last_login" title="Last Login" [wrapContent]="false"></go-table-column>
    <go-table-column field="alive"></go-table-column>
    <go-table-column field="login_attempts" title="Login Attempts"></go-table-column>
  </go-table>
</section>
